<template>
  <label
    :class="['price-input', {'price-input--focused': focused}]"
    :id="uid"
    @click="onFocus"
    v-click-outside="blur"
  >
    <span class="price-input__value">
      <span class="price-input__value-num">{{ priceDisplay(displayPrice, actuallyHideChange, fix) }}</span>
      <currency :measure="displayMeasure" :symbol="currency.symbol" class="price-input__currency"
                size="sm"
                v-if="currency.symbol"/>
      <span class="price-input__measure" v-else v-html="displayMeasure"/>
    </span>
    <!-- eslint-disable -->
    <transition
      appear
      enter-active-class="price-input__input--enter-active"
      enter-class="price-input__input--enter"
      enter-to-class="price-input__input--enter-to"
      name="a-input"
    >
      <div
        class="price-input__pop"
        v-show="focused"
      >
        <b-input
          :max="max"
          :min="min"
          :step="step"
          :value="value"
          @change="$emit('change', $event)"
          @input="$emit('input', $event)"
          @keyup.native.arrows="change($event)"
          class="price-input__pop-input"
          ref="input"
          size="sm"
          type="range"
          v-show="focused"
        />
      </div>
    </transition>
    <!-- eslint-enable -->
  </label>
</template>

<script>
  import Currency from "./Currency";
  import R, {is, isEmpty} from 'ramda'
  import priceFormatter from "../mixins/priceFormatter";

  export default {
    name: "PriceInput",
    components: {
      Currency
    },
    mixins: [
      priceFormatter
    ],
    model: {
      prop: 'value',
      event: 'input'
    },
    data() {
      return {
        type: 'text',
        focused: false
      }
    },
    props: {
      len: {
        type: [String, Number],
        default: 1
      },
      currency: {
        type: Object,
        default: () => ({}),
        validate: (v) => is(v.symbol, String)
      },
      purchase: {
        type: Object,
        default: () => ({})
      },
      hideChange: {
        type: Boolean,
        default: false
      },
      value: {
        type: [Number, String],
        default: ''
      },
      min: {
        type: [Number, String],
        default: 0
      },
      max: {
        type: [Number, String],
        default: Infinity
      },
      step: {
        type: [Number, String],
        default: 1
      },
      measure: {
        type: [String],
        default: ''
      }
    },
    computed: {
      displayMeasure() {
        if (isEmpty(this.purchase)) return this.measure;
        return this.purchase.measure;
      },
      displayPrice() {
        if (isEmpty(this.purchase)) return this.value;
        return this.value * this.purchase.multiplier;
      },
      actuallyHideChange() {
        return this.hideChange || ['UZS', 'KZT', 'RUB'].includes(this.currency.code)
      },
      fix() {
        if (this.currency.code === 'USD') return 2;
        else return 2;
      },
      width() {
        const symbol = (this.currency.symbol || '').trim().split('');
        const measure = (this.measure || '').trim().replace(/<.*>/g, '').split('');
        return (measure.length + symbol.length) * 0.6;
      },
      uid() {
        return `price_input_${Math.random().toString().slice(2)}`;
      }
    },
    methods: {
      onFocus(ev) {
        if (this.focused) {
          ev && ev.preventDefault();
          ev && ev.stopPropagation();
        }
        this.focus();
      },
      focus() {
        this.focused = true;
        this.$nextTick(() => {
          this.$refs.input.focus();
        })
      },
      blur() {
        this.focused = false;
        this.$nextTick(() => {
          this.$refs.input.blur();
        })
      },
      change({key}) {
        const keyIs = (keyCode) => R.always(R.equals(key, keyCode));

        let value = R.compose(
          R.ifElse(isNaN, R.always(0), R.identity),
          R.ifElse(R.gt(0), R.always(0), R.identity),
          (num) => num.toFixed(2),
          parseFloat,
          R.cond([
            [keyIs('ArrowUp'), R.add(this.step)],
            [keyIs('ArrowDown'), R.subtract(R.__, 1)],
            [keyIs('ArrowRight'), R.identity],
            [keyIs('ArrowLeft'), R.identity],
            [R.always(true), R.identity]
          ])
        )(this.value);
        this.$emit('input', value);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .price-input {
    display: block;
    position: relative;
    z-index: 0;
    height: 24px;
    width: 100%;
    margin-bottom: 0;
    cursor: pointer;
    border-radius: 2px;

    &--focused {
      z-index: 2;
      font-size: 1.2em;

      .price-input__value {
        z-index: 5;
        transform: translateY(-0.7em);
        font-size: inherit;
      }

      .price-input__pop-input {
        z-index: 4;
        position: absolute;
        left: 1em;
        bottom: 0.5em;
        right: 1em;
        max-width: calc(100% - 2em);

      }

      .price-input__pop {
        background-color: #ffffff;
        box-shadow: 0 10px 14px 4px rgba(0, 0, 0, 0.3);
        transform: translate3d(0, -1em, 6em);
        height: 4em;
      }
    }


    &__value {
      display: inline-block;
      position: relative;
      top: 0;
      left: 0;
      z-index: 0;
      transform: translateY(0);
      transition: transform 300ms ease-out;
      white-space: nowrap;
    }

    &__value-num {
      font-style: normal;
      font-weight: 500;
      font-size: 1em;
      line-height: 2em;

      color: #2D5EA3;
    }

    &__pop {
      position: absolute;
      top: 0;
      left: -2.5em;
      right: -2.5em;
      z-index: 0;
      box-sizing: border-box;
      height: 1.5em;
      padding: 0.5em;
      border-radius: 4px;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      transition: all 300ms ease-in, box-shadow 200ms ease-in;

      &--enter {
        opacity: 0;

        & .price-input__pop-input {

        }
      }

      &--enter-to {
        opacity: 1;
      }

      &--enter-active {
        transition: all 300ms ease-out;
      }

      &-input {
        box-sizing: border-box;
        margin: auto;
      }
    }

    &__currency,
    &__measure {
      white-space: nowrap;
      text-align: left;
    }

    &__measure sup {
      margin-left: -0.6em;
      left: 0.6em;
    }

    &__measure {
      display: inline-block;
      vertical-align: baseline;
      user-select: none;
      font-size: 0.8rem;
      font-weight: 400;
      line-height: 1.5rem;
      color: #555555;
      margin-left: 0.5em;

      & sup {
        position: relative;

      }
    }
  }
</style>
